import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11a3a708"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calender_content md:!tw-pb-16 md:!tw-box-border" }

import ProjectCalendar from "@/modules/nwg-calendar/components/ProjectCalendar.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarOverviewPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ProjectCalendar, { calendarType: "team" })
  ]))
}
}

})